import React, { useEffect, useState } from 'react'
import { Button, Modal, Popconfirm, message, Popover, Select, Descriptions, Space, Tag, Typography } from 'antd'
import { InfoCircleOutlined, DeleteOutlined, EditOutlined, UserOutlined, CalendarOutlined, ClockCircleOutlined, MedicineBoxOutlined, FileTextOutlined, BgColorsOutlined, DollarCircleOutlined, CheckCircleOutlined } from '@ant-design/icons'
import { deleteData, getData, sendDataBody } from '../../resources'
import { CreateCitaForm } from './create-cita-for-medic'

export default function DetailsCita({ citaForEdit, isModalOpen, setIsModalOpen, getCitasData, id_hospital, pacientesData, idsMedicos }) {

    const { _id: id_cita, medico: id_medico, servicio } = citaForEdit;

    const [citaPaid, setCitaPaid] = useState(false)

    const [payMethod, setPayMethod] = useState('efectivo')

    const [editingCita, setEditingCita] = useState(false)

    const handleOk = () => { setIsModalOpen(false); setEditingCita(false) }
    const handleCancel = () => { setIsModalOpen(false); setEditingCita(false) }

    //Check if paid before show confirm button
    useEffect(() => {
        checkPayment(citaForEdit._id)
    }, [citaForEdit])

    const checkPayment = (id_cita) => {
        getData(`balances/cita/${id_cita}`).then(rs => {
            if (rs.length > 0) {
                setCitaPaid(true)
            } else setCitaPaid(false)
        })
    }


    // Delete button
    const confirm = (e) => {
        deleteData(`citas/remove/${citaForEdit._id}`).then((rs) => { console.log(rs); getCitasData(); handleCancel() })
        deleteData(`balances/remove/cita/${citaForEdit._id}`)
    }
    const cancel = (e) => { console.log(e) }

    //Confirm payment
    const confirmPayment = () => {
        const balanceBody = {
            tipo: 'ingreso',
            medico: id_medico,
            cita: id_cita,
            monto: getAmmount(servicio),
            abono: getAmmount(servicio),
            forma_de_pago: payMethod,
            fecha_hora: new Date(),
            estado: 'pagado',
            concepto: servicio
        }
        console.log('Balance ready to send: ', balanceBody)
        sendDataBody('balances/add', balanceBody).then((rs) => { message.success(rs.message || rs.error); checkPayment(id_cita) })
    }



    const paymentOptions = [
        { value: 'efectivo', label: 'Efectivo' },
        { value: 'tarjeta', label: 'Tarjeta' },
        { value: 'transferencia', label: 'Transferencia' },
    ]
    const handleChange = (value) => {
        console.log(`selected ${value}`);
        setPayMethod(value)
    };
    const popoverContent = (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Typography.Text>Seleccione la forma de pago:</Typography.Text>
            <Select
                size='middle'
                defaultValue="efectivo"
                style={{ width: '100%' }}
                onChange={handleChange}
                options={paymentOptions}
            />
            <Button size='middle' type='primary' icon={<CheckCircleOutlined />} onClick={confirmPayment} block>
                Confirmar
            </Button>
        </div>
    );


    const getAmmount = (str) => {
        const match = str.match(/\$\d+/);
        if (match) {
            // Eliminamos el signo de dólar para obtener solo el número
            const number = match[0].replace('$', '');
            return number;
        } else {
            return 0;
        }
    }

    return <Modal 
        title={
            <Space>
                <InfoCircleOutlined style={{ color: '#1677ff', fontSize: '20px' }} />
                <span style={{ fontSize: '18px', fontWeight: 600 }}>Detalles de Cita</span>
            </Space>
        } 
        open={isModalOpen} 
        onOk={handleOk} 
        onCancel={handleCancel} 
        destroyOnClose 
        centered
        width={700}
        footer={[
            <Popconfirm
                key="delete"
                title="Eliminar Cita"
                description="¿Seguro que quiere eliminar la cita?"
                onConfirm={confirm}
                onCancel={cancel}
                okText="Sí, eliminar"
                cancelText="No"
                okButtonProps={{ danger: true }}
            >
                <Button danger icon={<DeleteOutlined />}>Eliminar</Button>
            </Popconfirm>,

            (!citaPaid && <Popover key="pay" content={popoverContent} title={<Typography.Text strong><DollarCircleOutlined /> Confirmación de pago</Typography.Text>} trigger="click">
                <Button type="primary" icon={<DollarCircleOutlined />}>Confirmar pago</Button>
            </Popover>),

            <Button key="edit" type={editingCita ? "default" : "primary"} ghost={!editingCita} onClick={() => setEditingCita(!editingCita)} icon={<EditOutlined />}>
                {editingCita ? "Cancelar" : "Modificar"}
            </Button>,
            <Button key="close" onClick={handleCancel}>Cerrar</Button>
        ]}>

        {
            editingCita ?
                <CreateCitaForm cita={citaForEdit} setIsModalOpen={setIsModalOpen} getCitasData={getCitasData} setEditingCita={setEditingCita} hospital={id_hospital} pacientesData={pacientesData} idsMedicos={idsMedicos} />
                : <div>{citaForEdit && 
                    <Descriptions column={1} bordered size="middle" labelStyle={{ fontWeight: '500', width: '160px', background: '#fafafa' }} style={{ marginTop: '16px' }}>
                        <Descriptions.Item label={<Space><UserOutlined /> Médico</Space>}>
                            {citaForEdit.doctor ? <Typography.Text strong>{citaForEdit.doctor.name}</Typography.Text> : <Typography.Text type="secondary">Sin médico</Typography.Text>}
                        </Descriptions.Item>
                        <Descriptions.Item label={<Space><UserOutlined /> Paciente</Space>}>
                            {citaForEdit.paciente ? <Typography.Text strong>{citaForEdit.paciente.name}</Typography.Text> : <Typography.Text type="secondary">Sin paciente</Typography.Text>}
                        </Descriptions.Item>
                        <Descriptions.Item label={<Space><CalendarOutlined /> Fecha</Space>}>
                            {new Date(citaForEdit.fecha_hora).toLocaleDateString()}
                        </Descriptions.Item>
                        <Descriptions.Item label={<Space><ClockCircleOutlined /> Hora</Space>}>
                            {new Date(citaForEdit.fecha_hora).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </Descriptions.Item>
                        <Descriptions.Item label={<Space><MedicineBoxOutlined /> Servicio</Space>}>
                            {citaForEdit.servicio ? <Tag color="blue">{citaForEdit.servicio}</Tag> : '-'}
                        </Descriptions.Item>
                        <Descriptions.Item label={<Space><FileTextOutlined /> Comentarios</Space>}>
                            {citaForEdit.comentarios || <Typography.Text type="secondary">Ninguno</Typography.Text>}
                        </Descriptions.Item>
                        <Descriptions.Item label={<Space><BgColorsOutlined /> Color</Space>}>
                            {citaForEdit.color ? <div style={{ width: 40, height: 16, backgroundColor: citaForEdit.color, borderRadius: 4, border: '1px solid #d9d9d9', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }} /> : '-'}
                        </Descriptions.Item>
                    </Descriptions>
                }
                </div>
        }
    </Modal >
}